@if (successionFacade.summaryInformation$ | async; as summaryInformation) {
  @if (summaryInformation.deceasedInformation; as deceasedInformation) {
    <ia-panel class="tw-mt-5">
      <div header class="">
        <span class="tw-pl-3 tw-text-lg tw-font-semibold tw-text-eerie-black">{{
          'screens.summary.deceasedInformation.title' | translate
        }}</span>
      </div>
      <div content class="tw-px-8 tw-pb-6 tw-pt-5">
        <div class="tw-flex tw-flex-col sm:tw-flex-row">
          <p
            class="tw-ml-5 tw-pb-3.5 tw-font-sans tw-text-base sm:tw-w-61 sm:tw-border-b sm:tw-border-b-geyser"
          >
            {{ 'screens.summary.deceasedInformation.name' | translate }}
          </p>
          <p
            class="tw-ml-5 tw-w-[400px] tw-border-b tw-border-b-geyser tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
          >
            {{ deceasedInformation.fullName }}
          </p>
        </div>
        <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
          <p
            class="tw-ml-5 tw-pb-3.5 tw-font-sans tw-text-base sm:tw-w-61 sm:tw-border-b sm:tw-border-b-geyser"
          >
            {{ 'screens.summary.deceasedInformation.birthday' | translate }}
          </p>
          <p
            class="tw-ml-5 tw-w-[400px] tw-border-b tw-border-b-geyser tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
          >
            {{ deceasedInformation.fullBirthday }}
          </p>
        </div>
        <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
          <p
            class="tw-ml-5 tw-pb-3.5 tw-font-sans tw-text-base sm:tw-w-61 sm:tw-border-b sm:tw-border-b-geyser"
          >
            {{ 'screens.summary.deceasedInformation.address' | translate }}
          </p>
          <p
            class="tw-ml-5 tw-w-[400px] tw-border-b tw-border-b-geyser tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
          >
            {{ deceasedInformation.fullAddress }}
          </p>
        </div>
        <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
          <p
            class="tw-ml-5 tw-pb-3.5 tw-font-sans tw-text-base sm:tw-w-61 sm:tw-border-b sm:tw-border-b-geyser"
          >
            {{ 'screens.summary.deceasedInformation.maritalStatus' | translate }}
          </p>
          <p
            class="tw-ml-5 tw-w-[400px] tw-border-b tw-border-b-geyser tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
          >
            {{ deceasedInformation.maritalStatus }}
          </p>
        </div>
        @if (deceasedInformation.iban) {
          <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
            <p
              class="tw-ml-5 tw-pb-3.5 tw-font-sans tw-text-base sm:tw-w-61 sm:tw-border-b sm:tw-border-b-geyser"
            >
              {{ 'screens.summary.deceasedInformation.iban' | translate }}
            </p>
            <p
              class="tw-ml-5 tw-w-[400px] tw-border-b tw-border-b-geyser tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
            >
              {{ deceasedInformation.iban }}
            </p>
          </div>
        }
        <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
          <p
            class="tw-ml-5 tw-pb-3.5 tw-font-sans tw-text-base sm:tw-w-61 sm:tw-border-b sm:tw-border-b-geyser"
          >
            {{ 'screens.summary.deceasedInformation.deceaseDate' | translate }}
          </p>
          <p
            class="tw-ml-5 tw-w-[400px] tw-border-b tw-border-b-geyser tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
          >
            {{ deceasedInformation.deceasedDate }}
          </p>
        </div>
        <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
          <p
            class="tw-ml-5 tw-pb-3.5 tw-font-sans tw-text-base sm:tw-w-61 sm:tw-border-b sm:tw-border-b-geyser"
          >
            {{ 'screens.summary.deceasedInformation.funeralExpenses' | translate }}
          </p>
          <p
            class="tw-ml-5 tw-w-[400px] tw-border-b tw-border-b-geyser tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
          >
            {{ deceasedInformation.funeralExpenses }}
          </p>
        </div>
      </div>
    </ia-panel>
  }
  @if (summaryInformation.reporterInformation; as reporterInformation) {
    <ia-panel class="tw-mt-5">
      <div header class="">
        <span class="tw-pl-3 tw-text-lg tw-font-semibold tw-text-eerie-black">{{
          'screens.summary.registrantInformation.title' | translate
        }}</span>
      </div>
      <div content class="tw-px-8 tw-pb-6 tw-pt-5">
        <div class="tw-flex tw-flex-col sm:tw-flex-row">
          <p
            class="tw-ml-5 tw-pb-3.5 tw-font-sans tw-text-base sm:tw-w-61 sm:tw-border-b sm:tw-border-b-geyser"
          >
            {{ 'screens.summary.registrantInformation.name' | translate }}
          </p>
          <p
            class="tw-ml-5 tw-w-[400px] tw-border-b tw-border-b-geyser tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
          >
            {{ reporterInformation.fullName }}
          </p>
        </div>
        <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
          <p
            class="tw-ml-5 tw-pb-3.5 tw-font-sans tw-text-base sm:tw-w-61 sm:tw-border-b sm:tw-border-b-geyser"
          >
            {{ 'screens.summary.registrantInformation.relationshipWithDeceased' | translate }}
          </p>
          <p
            class="tw-ml-5 tw-w-[400px] tw-border-b tw-border-b-geyser tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
          >
            {{ reporterInformation.relationshipWithDeceased }}
          </p>
        </div>
        <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
          <p
            class="tw-ml-5 tw-pb-3.5 tw-font-sans tw-text-base sm:tw-w-61 sm:tw-border-b sm:tw-border-b-geyser"
          >
            {{ 'screens.summary.registrantInformation.address' | translate }}
          </p>
          <p
            class="tw-ml-5 tw-w-[400px] tw-border-b tw-border-b-geyser tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
          >
            {{ reporterInformation.fullAddress }}
          </p>
        </div>
        <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
          <p
            class="tw-ml-5 tw-pb-3.5 tw-font-sans tw-text-base sm:tw-w-61 sm:tw-border-b sm:tw-border-b-geyser"
          >
            {{ 'screens.summary.registrantInformation.email' | translate }}
          </p>
          <p
            class="tw-ml-5 tw-w-[400px] tw-border-b tw-border-b-geyser tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
          >
            {{ reporterInformation.email }}
          </p>
        </div>
        <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
          <p
            class="tw-ml-5 tw-pb-3.5 tw-font-sans tw-text-base sm:tw-w-61 sm:tw-border-b sm:tw-border-b-geyser"
          >
            {{ 'screens.summary.registrantInformation.phoneNumber' | translate }}
          </p>
          <p
            class="tw-ml-5 tw-w-[400px] tw-border-b tw-border-b-geyser tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
          >
            {{ reporterInformation.phoneNumber }}
          </p>
        </div>
      </div></ia-panel
    >
  }
  @if (summaryInformation.hasNotary) {
    <ia-panel class="tw-mt-5">
      <div header class="">
        <span class="tw-pl-3 tw-text-lg tw-font-semibold tw-text-eerie-black">{{
          'screens.summary.notaryInformation.title' | translate
        }}</span>
      </div>
      <div content class="tw-px-8 tw-pb-6 tw-pt-5">
        @if (summaryInformation.notaryInformation; as notary) {
          @if (notary.fullName) {
            <div class="tw-flex tw-flex-col sm:tw-flex-row">
              <p
                class="tw-ml-5 tw-pb-3.5 tw-font-sans tw-text-base sm:tw-w-61 sm:tw-border-b sm:tw-border-b-geyser"
              >
                {{ 'screens.summary.notaryInformation.name' | translate }}
              </p>
              <p
                class="tw-ml-5 tw-w-[400px] tw-border-b tw-border-b-geyser tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
              >
                {{ notary.fullName }}
              </p>
            </div>
          }
          @if (notary.fullAddress) {
            <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
              <p
                class="tw-ml-5 tw-pb-3.5 tw-font-sans tw-text-base sm:tw-w-61 sm:tw-border-b sm:tw-border-b-geyser"
              >
                {{ 'screens.summary.notaryInformation.address' | translate }}
              </p>
              <p
                class="tw-ml-5 tw-w-[400px] tw-border-b tw-border-b-geyser tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
              >
                {{ notary.fullAddress }}
              </p>
            </div>
          }
          @if (notary.email) {
            <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
              <p
                class="tw-ml-5 tw-pb-3.5 tw-font-sans tw-text-base sm:tw-w-61 sm:tw-border-b sm:tw-border-b-geyser"
              >
                {{ 'screens.summary.notaryInformation.email' | translate }}
              </p>
              <p
                class="tw-ml-5 tw-w-[400px] tw-border-b tw-border-b-geyser tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
              >
                {{ notary.email }}
              </p>
            </div>
          }
          @if (notary.phoneNumber) {
            <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
              <p
                class="tw-ml-5 tw-pb-3.5 tw-font-sans tw-text-base sm:tw-w-61 sm:tw-border-b sm:tw-border-b-geyser"
              >
                {{ 'screens.summary.notaryInformation.phoneNumber' | translate }}
              </p>
              <p
                class="tw-ml-5 tw-w-[400px] tw-border-b tw-border-b-geyser tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
              >
                {{ notary.phoneNumber }}
              </p>
            </div>
          }
        } @else {
          <div class="tw-flex tw-flex-col sm:tw-flex-row">
            <p
              class="tw-ml-5 tw-pb-3.5 tw-font-sans tw-text-base sm:tw-border-b sm:tw-border-b-geyser"
            >
              {{ 'screens.summary.notaryInformation.noInformations' | translate }}
            </p>
          </div>
        }
      </div></ia-panel
    >
    <ng-template #noInformations>
      <ia-panel class="tw-mt-5">
        <div header class="">
          <span class="tw-pl-3 tw-text-lg tw-font-semibold tw-text-eerie-black">{{
            'screens.summary.notaryInformation.title' | translate
          }}</span>
        </div>
        <div content class="tw-px-8 tw-pb-6 tw-pt-5">
          <div class="tw-flex tw-flex-col sm:tw-flex-row">
            <p
              class="tw-ml-5 tw-pb-3.5 tw-font-sans tw-text-base sm:tw-border-b sm:tw-border-b-geyser"
            >
              {{ 'screens.summary.notaryInformation.noInformations' | translate }}
            </p>
          </div>
        </div></ia-panel
      >
    </ng-template>
  }
  @if (summaryInformation.inheritanceInformation; as inheritanceInformations) {
    <ia-panel class="tw-mt-5">
      <div header class="">
        <span class="tw-pl-3 tw-text-lg tw-font-semibold tw-text-eerie-black">{{
          'screens.summary.inheritanceInformation.title' | translate
        }}</span>
      </div>
      <div content class="tw-px-8 tw-pb-6 tw-pt-5">
        @if (inheritanceInformations.spouse; as spouse) {
          <div class="tw-flex tw-flex-col sm:tw-flex-row">
            <p
              class="tw-ml-5 tw-pb-3.5 tw-font-sans tw-text-base sm:tw-w-61 sm:tw-border-b sm:tw-border-b-geyser"
            >
              {{ 'screens.summary.inheritanceInformation.spouse' | translate }}
            </p>
            <div class="tw-ml-5 tw-flex tw-flex-col sm:tw-border-b sm:tw-border-b-geyser">
              @if (spouse.fullName) {
                <p
                  class="tw-w-[400px] tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
                >
                  {{ spouse.fullName }}
                </p>
              }
              @if (spouse.fullAddress) {
                <p
                  class="tw-w-[400px] tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
                >
                  {{ spouse.fullAddress }}
                </p>
              }
              @if (spouse.email) {
                <p
                  class="tw-w-[400px] tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
                >
                  {{ spouse.email }}
                </p>
              }
              @if (spouse.phoneNumber) {
                <p
                  class="tw-w-[400px] tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
                >
                  {{ spouse.phoneNumber }}
                </p>
              }
            </div>
          </div>
        }
        @if (inheritanceInformations.children) {
          @for (child of inheritanceInformations.children; track child; let i = $index) {
            <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
              <p
                class="tw-ml-5 tw-pb-3.5 tw-font-sans tw-text-base sm:tw-w-61 sm:tw-border-b sm:tw-border-b-geyser"
              >
                {{ ('screens.summary.inheritanceInformation.child' | translate) + (i + 1) }}
              </p>
              <div class="tw-ml-5 tw-flex tw-flex-col sm:tw-border-b sm:tw-border-b-geyser">
                @if (child?.fullName) {
                  <p
                    class="tw-w-[400px] tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
                  >
                    {{ child?.fullName }}
                  </p>
                }
                @if (child?.fullAddress) {
                  <p
                    class="tw-w-[400px] tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
                  >
                    {{ child?.fullAddress }}
                  </p>
                }
                @if (child?.email) {
                  <p
                    class="tw-w-[400px] tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
                  >
                    {{ child?.email }}
                  </p>
                }
                @if (child?.phoneNumber) {
                  <p
                    class="tw-w-[400px] tw-pb-3.5 tw-font-sans tw-text-base tw-font-semibold tw-text-gray"
                  >
                    {{ child?.phoneNumber }}
                  </p>
                }
              </div>
            </div>
          }
        }
        <div class="tw-mt-8 tw-flex tw-items-center">
          <ia-icons name="information_white" class="tw-size-6 tw-shrink-0" color="#a33467" />
          <p class="tw-ml-2.5 tw-font-sans tw-text-sm tw-text-gray">
            {{ 'screens.summary.inheritanceInformation.information' | translate }}
          </p>
        </div>
      </div></ia-panel
    >
  }
  @if (summaryInformation.documents; as documents) {
    <ia-panel class="tw-mt-5">
      <div header class="">
        <span class="tw-pl-3 tw-text-lg tw-font-semibold tw-text-eerie-black">{{
          'screens.summary.documents.title' | translate
        }}</span>
      </div>
      <div content class="tw-px-8 tw-pb-6 tw-pt-5">
        <div class="tw-flex tw-flex-col tw-border-b tw-border-b-geyser tw-pb-3.5">
          <p class="tw-font-sans tw-text-base">
            {{ 'screens.summary.documents.deceaseProof' | translate }}
          </p>
          @for (document of documents.deathCertificateDocument; track document) {
            <div class="tw-mt-3.5 tw-flex">
              <ia-icons class="tw-size-5" name="arrow_down_line_black" color="#00915a" />
              <a
                [href]="document.link"
                [download]="document.filename"
                class="tw-ml-2.5 tw-font-sans tw-text-base tw-font-semibold tw-text-sea-green tw-underline"
              >
                {{ document.label }}
              </a>
            </div>
          }
        </div>
        @if (documents.otherDocuments?.length) {
          <div class="tw-flex tw-flex-col tw-border-b tw-border-b-geyser tw-py-3.5">
            <p class="tw-font-sans tw-text-base">
              {{ 'screens.summary.documents.complementaryDocuments' | translate }}
            </p>
            @for (document of documents.otherDocuments; track document) {
              <div class="tw-mt-3.5 tw-flex">
                <ia-icons class="tw-size-5" name="arrow_down_line_black" color="#00915a" />
                <a
                  [href]="document.link"
                  [download]="document.filename"
                  class="tw-ml-2.5 tw-font-sans tw-text-base tw-font-semibold tw-text-sea-green tw-underline"
                >
                  {{ document.label }}
                </a>
              </div>
            }
          </div>
        }
        @if (documents.funeralExpenses?.length) {
          <div class="tw-flex tw-flex-col tw-border-b tw-border-b-geyser tw-py-3.5">
            <p class="tw-font-sans tw-text-base">
              {{ 'screens.summary.documents.funeralExpenses' | translate }}
            </p>
            @for (document of documents.funeralExpenses; track document) {
              <div class="tw-mt-3.5 tw-flex">
                <ia-icons class="tw-size-5" name="arrow_down_line_black" color="#00915a" />
                <a
                  [href]="document.link"
                  [download]="document.filename"
                  class="tw-ml-2.5 tw-font-sans tw-text-base tw-font-semibold tw-text-sea-green tw-underline"
                >
                  {{ document.label }}
                </a>
              </div>
            }
          </div>
        }
      </div></ia-panel
    >
  }
  <section
    class="tw-mt-5 tw-flex tw-flex-col tw-border tw-border-solid tw-bg-white tw-px-5 tw-py-7.5 tw-font-bnpp-sans sm:tw-mt-7.5 sm:tw-px-7.5 sm:tw-py-10"
  >
    <div class="tw-flex">
      <ia-checkbox class="tw-accent-[#50d71e]" [(ngModel)]="summaryFacade.cguAccepted" />
      <p class="tw-ml-3.5 tw-font-sans tw-text-base tw-text-eerie-black">
        {{ 'screens.summary.conditions.checkbox' | translate }}
      </p>
    </div>
    <div
      [innerHTML]="'screens.summary.conditions.data' | translate"
      class="tw-mt-8 tw-max-w-none prose-p:tw-mt-3.5 prose-p:tw-font-sans prose-p:tw-text-sm prose-a:tw-font-semibold prose-a:tw-text-sea-green prose-a:tw-underline"
    ></div>
  </section>
}

@if (
  {
    isLoading: successionFacade.customerInformationIsLoading$ | async,
    isPrevious: successionFacade.isPreviousPageLoading$ | async,
    isNext: successionFacade.isNextPageLoading$ | async,
  };
  as vm
) {
  <div
    class="tw-mt-5 tw-flex tw-flex-col tw-items-center tw-justify-end tw-space-x-2 sm:tw-flex-row"
  >
    <button
      (click)="summaryFacade.onPrevious()"
      iaButton
      type="button"
      id="btn-summary-previous"
      data-test-id="btn-summary-previous"
      variant="secondary"
      [disabled]="vm.isLoading"
      [isProcessing]="!!vm.isLoading && !!vm.isPrevious"
    >
      {{ 'screens.summary.buttons.previous' | translate }}
    </button>
    <button
      (click)="summaryFacade.onNext()"
      iaButton
      type="button"
      id="btn-summary-next"
      data-test-id="btn-summary-next"
      variant="primary"
      [disabled]="vm.isLoading || !summaryFacade.cguAccepted"
      [isProcessing]="!!vm.isLoading && !!vm.isNext"
    >
      {{ 'screens.summary.buttons.next' | translate }}
    </button>
  </div>
}
